import MainLayout from './features/layouts/mainLayout';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, ToastContainer } from 'react-toastify';
import ScrollToTop from './features/scrollToTop';
import FloatingContact from './components/floatingContact';
import { useAddDispatch } from './store';
import { loadUserFromStorage } from './auth/userSlice';
import { useEffect } from 'react';
import { PageTracker } from './features/pageTracker';
import SEOContent from './features/seo';
import { useLocation } from 'react-router-dom';

function App() {
  const dispatch = useAddDispatch();
  const location = useLocation();
  const isBrochureViewer = location.pathname.startsWith("/e-brochure");

  useEffect(() => {
    dispatch(loadUserFromStorage());
  }, [dispatch]);

  return (
    <>
      <SEOContent />
      <PageTracker />
      <ScrollToTop />
      {!isBrochureViewer && <FloatingContact />}
      <MainLayout />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </>
  );
}

export default App;
